import {
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  PageHeader,
  Popconfirm,
  Space,
  Switch,
  Table,
  Tooltip,
  notification,
} from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { AdminService } from "../../../services/AdminService";
import NewNewsForm from "./NewNewsForm";

const NewsAdmin = () => {
  const [initialRender, setInitialRender] = useState(true);
  const [newsler, setNewsler] = useState(null);
  const [newPanel, setNewPanel] = useState(false);
  const router = useHistory();

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      AdminService.getNews().then((data) => {
        console.log(data.data);
        setNewsler(data.data);
      });
    }
  }, [initialRender]);

  const activeChanged = (a) => {
    AdminService.changeNewsActive(a).then((data) => {
      setInitialRender(true);
      notification.success({
        message: "Success!",
        description: "News updated",
      });
    });
  };

  const favoriteChanged = (a) => {
    AdminService.changeNewsFavorite(a).then((data) => {
      setInitialRender(true);
      notification.success({
        message: "Success!",
        description: "News updated",
      });
    });
  };
  const goDetails = (veri) => {
    router.push(`/admin/news/${veri.id}/details`, { veri });
  };
  const goEdit = (veri) => {
    router.push(`/admin/news/${veri.id}/edit`, { veri });
  };
  const deleteNews = (id) => {
    AdminService.deleteNews(id).then((data) => {
      notification.success({
        message: "Success!",
        description: "Your News has been deleted successfully",
      });
      setInitialRender(true);
    });
  };
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Short Description",
      dataIndex: "description",
    },
    {
      title: "is Active?",

      render: (item) => (
        <Switch
          checked={item.isActive}
          onChange={() => activeChanged(item.id)}
        />
      ),
    },
    {
      title: "is Favorite?",
      render: (item) => (
        <Switch
          checked={item.isFavorite}
          onChange={() => favoriteChanged(item.id)}
        />
      ),
    },
    {
      title: "Actions",
      render: (item) => (
        <Space>
          <Tooltip title="News Details" placement="left" key={item.id}>
            <Button
              type="primary"
              onClick={() => goDetails(item)}
              icon={<SearchOutlined />}
            />
          </Tooltip>
          <Tooltip title="Edit News" placement="left" key={item.id}>
            <Button
              type="default"
              onClick={() => goEdit(item)}
              icon={<EditOutlined />}
            />
          </Tooltip>
          <Tooltip title="Delete News" placement="left" key={item.title}>
            <Popconfirm
              title="Are you sure ?"
              onConfirm={() => deleteNews(item.id)}
              okText="Yes! Delete."
              cancelText="Cancel"
            >
              <Button type="primary" danger icon={<DeleteOutlined />} />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];
  return (
    <div className="max-w-5xl">
      <PageHeader
        className="site-page-header"
        onBack={() => router.goBack()}
        title={newPanel ? "Add New News" : "News List"}
        extra={[
          <Button
            key="a"
            onClick={() => setNewPanel(!newPanel)}
            icon={newPanel ? <CloseOutlined /> : <PlusOutlined />}
            type="primary"
            danger={newPanel}
          >
            {newPanel ? "Cancel" : "Add News"}
          </Button>,
        ]}
      />
      {!newPanel && (
        <Table
          scroll={{ x: 600 }}
          loading={newsler === null}
          dataSource={newsler}
          bordered
          columns={columns}
          size="small"
        />
      )}
      {newPanel && (
        <NewNewsForm sir={setInitialRender} newPanel={setNewPanel} />
      )}
    </div>
  );
};

export default NewsAdmin;
